import React from "react";
import "../assets/css/InfiniteElement.css";
import { useTranslation } from "react-i18next";

const InfiniteElement = () => {
  const { t } = useTranslation();
  return (
    <>
    <div className="container section-title" data-aos="fade-up">
        <h2>{t("Infiniteelementskills")}</h2>
        <h1 className="services-title">{t("InfiniteelementAccroche")}</h1>
    </div>
    <div className="infinite-element" data-aos="fade-up">
      <div className="infinite-container">
        <div className="tag-list">
          {/* Ombre latérale */}
          <div className="shadow-overlay"></div>
          
          {[
            { duration: "18365ms", direction: "normal", tags: ["EC2", "S3", "RDS", "Lambda", "VPC", "Route 53", "CloudFront", "ECS", "DynamoDB", "Amplify", "Cognito", "API Gateway", "CUR"] },
            { duration: "18365ms", direction: "reverse", tags: ["Terraform", "CloudFormation", "Ansible", "Github", "Gitlab", "CodePipeline", "Bitbucket"] },
            { duration: "18365ms", direction: "normal", tags: ["Python", "PS", "Bash", "Node.js", "Ts", "Java", "C#", "HTML", "CSS", "Solidity"] },
            { duration: "18365ms", direction: "reverse", tags: ["IAM", "Secret Manager", "Vault", "ACM", "WAF"] },
            { duration: "18365ms", direction: "normal", tags: ["CloudWatch", "Dynatrace", "Nagios", "Datadog"] },
          ].map((slider, index) => (
            <div
              key={index}
              className="loop-slider"
              style={{ "--duration": slider.duration, "--direction": slider.direction }}
            >
              <div className="inner">
                {slider.tags.map((tag, i) => (
                  <div className="tag" key={i}>
                    <span>#</span> {tag}
                  </div>
                ))}
                {/* Duplication pour effet d'infini */}
                {slider.tags.map((tag, i) => (
                  <div className="tag" key={`duplicate-${i}`}>
                    <span>#</span> {tag}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default InfiniteElement;
